import { GenIcon } from 'react-icons';
export const MdCurrencyFlagGbp = GenIcon({
    tag: 'svg',
    attr: {
        viewBox: '0 0 24 24',
        fill: 'none',
        xmlns: 'http://www.w3.org/2000/svg',
    },
    child: [
        {
            tag: 'g',
            attr: { clipPath: 'url(#clip0_21686_30045)' },
            child: [
                {
                    tag: 'path',
                    attr: {
                        d: 'M8.00797 0.6875V7.32044L2.56415 4.59515C3.96156 2.8216 5.84158 1.451 8.00797 0.6875Z',
                        fill: '#223C72',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M21.4386 4.59515L15.9948 7.32044V0.6875C18.1611 1.451 20.0438 2.8216 21.4386 4.59515Z',
                        fill: '#223C72',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M8.00797 16.6797V23.31C5.84158 22.5465 3.95891 21.1759 2.56415 19.4023L8.00797 16.6797Z',
                        fill: '#223C72',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M21.4386 19.4023C20.0438 21.1759 18.1611 22.5465 15.9948 23.31V16.6797L21.4386 19.4023Z',
                        fill: '#223C72',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M24.0001 12.0016C24.0001 12.8234 23.9179 13.6241 23.7615 14.4009C23.6475 14.947 23.5016 15.4772 23.316 15.9942H19.959L22.7273 17.3807C22.3641 18.0992 21.9345 18.7778 21.4386 19.4062L15.9948 16.6835V23.3139C15.4804 23.4995 14.9474 23.6479 14.4038 23.7593C13.6296 23.9184 12.8261 24.0005 12.0014 24.0005C11.1768 24.0005 10.3786 23.9184 9.60171 23.7593C9.05548 23.6479 8.52514 23.5021 8.00807 23.3139V16.6835L2.56425 19.4062C2.3972 19.1941 2.23546 18.974 2.08166 18.746L7.58382 15.9942H3.99879L1.26495 17.3621C0.800915 16.4369 0.453554 15.4427 0.241422 14.4009C0.0823239 13.6267 0.00012207 12.8234 0.00012207 12.0016C0.00012207 11.1797 0.0823239 10.3765 0.241422 9.59969C0.352791 9.05621 0.501279 8.52333 0.684242 8.00637H4.02266L1.27025 6.63044C1.63353 5.90668 2.07105 5.22535 2.56161 4.59438L8.00543 7.31973V0.686639C8.5225 0.501061 9.05282 0.352598 9.59906 0.241251C10.3733 0.0821846 11.1768 0 11.9988 0C12.8208 0 13.6243 0.0821846 14.4012 0.241251C14.9448 0.352598 15.4778 0.49841 15.9922 0.686639V7.31973L21.436 4.59438C21.603 4.80382 21.7621 5.02121 21.9133 5.2439L16.3952 8.00637H19.9802L22.73 6.63044C23.1993 7.55833 23.5493 8.55515 23.7615 9.59969C23.9179 10.3738 24.0001 11.1771 24.0001 12.0016Z',
                        fill: '#FFFFFF',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M4.02524 8.0048H0.686829C0.853882 7.53026 1.0501 7.07428 1.27284 6.62891L4.02524 8.0048Z',
                        fill: '#EF3827',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M23.3186 15.9922C23.1515 16.4694 22.9527 16.9307 22.7299 17.3787L19.9616 15.9922H23.3186Z',
                        fill: '#EF3827',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M22.7299 6.62869L19.9802 8.00459H16.3951L21.9132 5.24219C22.2155 5.68491 22.4886 6.1462 22.7299 6.62869Z',
                        fill: '#EF3827',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M7.58637 15.9922L2.08422 18.744C1.78193 18.3039 1.51147 17.8426 1.26752 17.3601L4.00136 15.9922H7.58637Z',
                        fill: '#EF3827',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M24 12.0028C24 12.8247 23.9178 13.6253 23.7614 14.4021H14.4038V23.7579C13.6295 23.917 12.826 23.9991 12.0014 23.9991C11.1767 23.9991 10.3786 23.917 9.60163 23.7579V14.4021H0.243986C0.0848874 13.628 0.00268555 12.8247 0.00268555 12.0028C0.00268555 11.181 0.0848874 10.3777 0.243986 9.60094H9.60163V0.245158C10.3759 0.0860908 11.1794 0.00390625 12.0014 0.00390625C12.8234 0.00390625 13.6268 0.0860908 14.4038 0.245158V9.60094H23.7614C23.9178 10.3751 24 11.1784 24 12.0028Z',
                        fill: '#EF3827',
                    },
                    child: [],
                },
                {
                    tag: 'path',
                    attr: {
                        d: 'M12 0.5C18.3512 0.5 23.4999 5.64869 23.5 12C23.5 18.3514 18.3513 23.501 12 23.501C5.64874 23.501 0.5 18.3514 0.5 12C0.500145 5.64869 5.64883 0.5 12 0.5Z',
                        stroke: 'white',
                    },
                    child: [],
                },
            ],
        },
        {
            tag: 'defs',
            attr: {},
            child: [
                {
                    tag: 'clipPath',
                    attr: { id: 'clip0_21686_30045' },
                    child: [
                        {
                            tag: 'rect',
                            attr: {
                                width: '24',
                                height: '24',
                                rx: '12',
                                fill: 'white',
                            },
                            child: [],
                        },
                    ],
                },
            ],
        },
    ],
});
